import React, { Component, PropTypes } from 'react';
import Icon from './Icon';

export default class Sort extends Icon {
  static defaultProps = {
    color: '#FFFFFF',
    size: 16,
    viewPortSize: 18
  };

  render() {
    let { color, size, viewPortSize, className, ...props } = this.props;

    return (
      <svg
        width={size}
        height={size}
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox={'0 0 ' + viewPortSize + ' ' + viewPortSize}
        {...props}
      >
        <g fill={color}>
          <polygon points="18.5,4.8 14.3,2.4 13.5,2.4 9.3,4.8 10,6.1 13.1,4.3 13.1,13 14.6,13 14.6,4.3 17.7,6.1  " />
          <polygon points="6.9,15.7 6.9,7 5.4,7 5.4,15.7 2.3,13.9 1.5,15.2 5.7,17.6 6.5,17.6 10.7,15.2 10,13.9   " />
        </g>
      </svg>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Icons/Sort.js